import Vue from 'vue';
import iView from 'iview';
import {
    router
} from './router/index';
import {
    appRouter
} from './router/router';
import store from './store';
import App from './App.vue';
// import '@/locale';
import 'iview/dist/styles/iview.css';
// import axios from "@/libs/axiosTool"
// import VueI18n from 'vue-i18n';
import app from './libs/ajax';
import socket from './libs/communication';
import cascaderMulti from "cascader-multi";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import TreeTable from 'vue-table-with-tree-grid'
import misc from '@/libs/misc'
import directive from '@/directive/directive';
import '@/libs/jquery-ui.min.js';
import { ColorPicker,Button, Tree } from 'element-ui';
// import { Tree as ElTree } from 'element-ui';  
// import 'element-ui/lib/theme-chalk/index.css';
import VueClipboard from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload'
Vue.use(VueClipboard);
Vue.use(VueLazyload)
Vue.use(Button)
Vue.component("ele-colorpicker", ColorPicker);
Vue.component("ele-tree", Tree);
Vue.component('tree-table', TreeTable);
Vue.component('Treeselect',Treeselect)
Vue.use(cascaderMulti);
// Vue.use(VueI18n);
Vue.use(iView);
// Vue.use(axios)
Vue.prototype.$app = app;
// Vue.prototype.$_commSocket = _commSocket;
Vue.prototype.$misc = misc;
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$deepCopy = function (obj){return JSON.parse(JSON.stringify(obj))}
new Vue({
    el: '#app',
    router: router,
    store: store,
    render: h => h(App),
    data: {
        currentPageName: ''
    },
    mounted() {
        this.currentPageName = this.$route.name;
        // 显示打开的页面的列表
        this.$store.commit('setOpenedList');
        this.$store.commit('initCachepage');
        // // 权限菜单过滤相关
        // this.$store.commit('updateMenulist');
        // 初始化会议室选择
        this.$store.commit('initMeetingNum');
        // iview-admin检查更新
        //util.checkUpdate(this);
        //毫秒转为时分秒
        Date.prototype.format = function (fmt) {
            var o = {
                "M+": this.getMonth() + 1, // 月份，从0开始，所以要+1
                "d+": this.getDate(),      // 日
                "h+": this.getHours(),     // 小时（24小时制）
                "m+": this.getMinutes(),   // 分
                "s+": this.getSeconds(),   // 秒
                "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
                "S": this.getMilliseconds() // 毫秒（通常不用于日期格式）
            };
         
            // 处理年份
            if (/(y+)/.test(fmt)) {
                var yearStr = this.getFullYear() + "";
                fmt = fmt.replace(RegExp.$1, yearStr.substr(4 - RegExp.$1.length));
            }
         
            // 处理其他部分
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    var replacement = (RegExp.$1.length == 1) ? o[k] : ("00" + o[k]).substr(("" + o[k]).length);
                    fmt = fmt.replace(RegExp.$1, replacement);
                }
            }

            return fmt;
        }
    },
    created() {
        let tagsList = [];
        appRouter.map((item) => {
            if (item.children.length <= 1) {
                tagsList.push(item.children[0]);
            } else {
                tagsList.push(...item.children);
            }
        });
        this.$store.commit('setTagsList', tagsList);
    }
});



// WEBPACK FOOTER //
// ./src/main.js